module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_004.png
// module id = 1128
// module chunks = 0